import Handsontable, { CellRange } from "handsontable";
import _ from "lodash";
import { ObjectUtils } from "../../../utils/object-utils";

export class SelSum {

    constructor(
        readonly hotInstance: Handsontable
    ) {
    }

    getSelectedSum(): number {
        if (!this.hotInstance) {
            return null;
        }
        const selected = this.getSelectedCells(this.hotInstance.getSelectedRange());
        return this.calculateSelectedCells(selected, this.hotInstance);
    }

    getSelection(): any[] {
        if (!this.hotInstance) {
            return null;
        }
        const range = this.hotInstance.getSelectedRange();
        if (!range) {
            return [];
        }

        const selected = this.getSelectedCells(range);
        const selections = [];
        if (ObjectUtils.hasValue(selected)) {
            return selected.map(item => [
                item[0],
                item[1]
            ]);
        }

        return selections;
    }

    private getSelectedCells(selectedRanges: CellRange[]) {
        const selections = [];

        selectedRanges.forEach((range: CellRange) => {
            const startRow = range.from.row <= range.to.row ? range.from.row : range.to.row;
            const endRow = range.from.row >= range.to.row ? range.from.row : range.to.row;
            const startCol = range.from.col <= range.to.col ? range.from.col : range.to.col;
            const endCol = range.from.col >= range.to.col ? range.from.col : range.to.col;
            selections.push({ from: { row: startRow,
                col: startCol },
            to: { row: endRow,
                col: endCol } });
        });

        const selected = [];
        selections.forEach(sel => {
            for (let i = sel.from.row; i <= sel.to.row; i++) {
                for (let j = sel.from.col; j <= sel.to.col; j++) {
                    if (!selected.includes([
                        i,
                        j,
                        i,
                        j
                    ])) {
                        selected.push([
                            i,
                            j,
                            i,
                            j
                        ]);
                    }
                }
            }
        });

        return _.uniqWith(selected, _.isEqual);
    }

    private calculateSelectedCells(selected: any, hotInstance: any) {
        let sum = 0;
        if (ObjectUtils.hasValue(selected)) {
            selected.forEach(item => {
                // eslint-disable-next-line prefer-spread
                const dataValue = hotInstance.getData.apply(hotInstance, item);
                dataValue.forEach(element => {
                    if (ObjectUtils.hasValue(element[0]) && !isNaN(element[0])) {
                        sum += element[0] * 1;
                    }
                });
            });
        }
        return sum;
    }
}
